import styled from 'styled-components'
import cross from '../../assets/addStockModal/pages/cross.svg'
import check from '../../assets/addStockModal/pages/check.svg'
import arrowDown from '../../assets/certificates/AddParameter/arrow-down.svg'

export const Container = styled.div`
    position: absolute;
    width: 42.5rem;
    height: 38.5rem;
    max-height: 90vh;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    padding: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;
    width: 24px;
    height: 24px;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 12px;
    height: 12px;
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
    color: #303030;
`

export const InfoProduction = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 3.5vh;
`

export const StatusProduction = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

export const TimeProduction = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

export const InfoText = styled.span`
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #303030;
`

export const NameInfo = styled.span`
    font-family: Inter, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: #303030;
`

export const Separator = styled.hr`
  border: none;
  height: 1px;
  background-color: #EBEBEB;
  margin: 15px 0;
`

export const Labor = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
`

export const Employees = styled.div`
    display: grid;
    margin-top: 4.5vh;
`

export const Select = styled.select`
    width: 19rem;
    height: 2.5rem;
    border-radius: 20px;
    background-color: #EBEBEB;
    margin-top: 1rem;
`

export const ItemsTable = styled.div`
    margin-top: 1.5rem;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
`

export const TableItemsContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    
    &::-webkit-scrollbar {
        width: 8px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 10px;
    }
    
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`

export const TableTitle = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 0.5rem;
`

export const TableText = styled.span`
    font-family: Inter, sans-serif;
    font-size: 12px;
    color: #696969;
    font-weight: 400;
`

export const TableInfo = styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background-color: #F4F4F4;
    border-bottom: 1px solid #C4C4C4;
    height: 2.5rem;
    align-items: center;
    padding: 0.5rem;
    border-radius: 8px 8px 0 0;
`

export const TableInfoText = styled.span`
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: #696969;
`

export const ActionsDiv = styled.div`
    display: flex;
    justify-content: end;
    align-items: center;
    padding: 1.5rem 0 0 0;
    gap: 16px;
    margin-top: auto;
    flex-shrink: 0;
`

export const CloseButton = styled.button`
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    color: #0090D3;
    border: none;
    background-color: transparent;
    cursor: pointer;
`

export const HalfButton = styled.button`
    width: 8rem;
    height: 2.5rem;
    border-radius: 20px;
    border: 1px solid #0090D3;
    background-color: #FFFFFF;
    color: #0090D3;
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`

export const PlayButton = styled.button`
    width: 11rem;
    height: 2.5rem;
    border-radius: 20px;
    border: none;
    background-color: #0090D3;
    color: #FFFFFF;
    font-family: Inter, sans-serif;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
`

export const SplitContainer = styled(Container)`
    width: 28rem;
    height: auto;
    max-height: 90vh;
    overflow-y: auto;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`

export const SplitHeaderDiv = styled(HeaderDiv)`
    margin-bottom: 12px;
`

export const SplitHeaderText = styled(HeaderText)`
    font-size: 18px;
    font-weight: 600;
`

export const SplitInfoText = styled(InfoText)`
    margin-bottom: 16px;
    font-size: 12px;
    color: #696969;
    line-height: 1.5;
    font-weight: 400;
`

export const SplitInfoProduction = styled(InfoProduction)`
    grid-template-columns: 1fr;
`

export const SplitItemsWrapper = styled.div`
    margin-top: 20px;
`

export const SplitItemsTitle = styled.div`
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #303030;
`

export const SplitTableHeader = styled.div`
    display: grid;
    grid-template-columns: 50px 1fr 2fr 80px 80px;
    padding: 10px 12px;
    font-size: 12px;
    color: #696969;
    font-weight: 400;
    background-color: #F5F5F5;
    border-radius: 4px 4px 0 0;
`

export const SplitTableBody = styled.div`
    max-height: 200px;
    overflow-y: auto;
`

export const SplitTableRow = styled.div<{ isEven: boolean }>`
    display: grid;
    grid-template-columns: 50px 1fr 2fr 80px 80px;
    padding: 12px;
    align-items: center;
    cursor: pointer;
    background-color: ${props => props.isEven ? '#FFFFFF' : '#F5F5F5'};
    border-bottom: 1px solid #E0E0E0;
`

export const SplitCheckbox = styled.input`
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #0090D3;
`

export const SplitTableCell = styled.div`
    font-size: 13px;
    color: #303030;
`

export const SplitActionsDiv = styled.div`
    margin-top: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

export const SplitCancelButton = styled.button`
    font-size: 14px;
    font-weight: 600;
    color: #E74C3C;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 8px 0;
    font-family: Inter, sans-serif;
`

export const SplitButtonsGroup = styled.div`
    display: flex;
    gap: 12px;
`

export const SplitBackButton = styled.button`
    font-size: 14px;
    font-weight: 600;
    color: #0090D3;
    background: transparent;
    border: 1px solid #0090D3;
    border-radius: 20px;
    padding: 8px 20px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: Inter, sans-serif;

    &:hover {
        background-color: #E8F5FA;
    }
`

export const SplitAdvanceButton = styled.button<{ disabled?: boolean }>`
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
    background: ${props => props.disabled ? '#CCCCCC' : '#0090D3'};
    border: none;
    border-radius: 20px;
    padding: 8px 24px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s;
    font-family: Inter, sans-serif;

    &:hover {
        background-color: ${props => props.disabled ? '#CCCCCC' : '#007AB8'};
    }
`